<template>
    <div class="row mb-3">
        <div class="col-sm-6 mx-auto">
            <!-- Header -->
            <div class="py-3 mb-3 border-bottom">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-6 d-flex">
                            <h5 class="m-0 p-0 align-self-center">
                                <i class="fas fa-pencil-alt mr-2"></i> Reenviar Redação
                            </h5>
                        </div>
                        <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">
                            <b-button class="mr-0" size="sm" variant="outline-secondary" v-b-modal.modalPreview>
                                <i class="fas fa-eye mr-1"></i>
                                Ver Redação Enviada
                            </b-button>

                            <b-modal id="modalPreview" title="Prévia da Redação Enviada" size="lg" hide-footer>
                                <img :src="essay.preview" class="img-thumbnail w-100" alt="Redação Problema" />
                            </b-modal>
                        </div>
                    </div>
                </div>
            </div>

            <div>

                <div class="alert alert-danger mb-3" v-if="essay.block_message">
                    <b>Motivo:</b> {{ essay.block_message }}
                </div>

                <b-overlay :show="loading" rounded="sm">
                    <b-card>
                        <b-form @submit="submit" @submit.stop.prevent>
                            <!-- Field -->
                            <b-form-group
                                label="Imagem da Redação"
                                description="Envie a imagem da redação que será corrigida">

                                <!-- Input -->
                                <s3-file-input
                                    id="imageFile"
                                    @success="handleImageSuccess"
                                    accept="image/*"
                                    placeholder=""
                                    browse-text="Procurar"
                                    path="essays"
                                    :can-clear="true"
                                    :disabled="!!form.content_img_path || !!imageConvertPath"
                                    no-drop
                                    :max-file-size="5242880"
                                ></s3-file-input>

                                <div v-if="imageConvertPath">
                                    <b-alert variant="info" class="mt-2" show>
                                        <b-spinner class="mr-2" small></b-spinner>
                                        convertendo a imagem, aguarde alguns instantes ...
                                    </b-alert>
                                </div>

                                <div v-if="form.content_img_path" class="mt-2">
                                    <b-button @click="clearImage" variant="outline-danger" size="sm" v-b-tooltip.hover title="Remover Imagem">
                                        <!-- Change Icon -->
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                    <img :src="preview" class="img-thumbnail mt-2" width="100%" alt="" />
                                </div>

                                <!-- Error -->
                                <has-errors :errors="errors" name="content_img_path" />
                            </b-form-group>

                            <!-- Submit -->
                            <b-button type="submit" variant="primary" :disable="loading">
                                Reenviar Redação
                            </b-button>

                        </b-form>
                    </b-card>
                </b-overlay>
            </div>
        </div>
    </div>
</template>

<script>
// Cropper
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
    components: {
        Cropper,
    },
    props: ['essay'],
    data() {
        return {
            loading: false,
            loadingOptimize: false,
            preview: null,
            errors: {},
            form: {
                content_img_path: null
            },
            imageConvertInterval: null,
            imageConvertPath: null,
            imageConvertIntervalTime: 10000,
        }
    },
    methods: {
        submit() {
            let exec = true;

            if (this.preview && !this.form.content_img_path) {
                exec = false;
                this.$toast.warning('Você precisa finalizar a edição da imagem da redação que você inseriu, basta clicar no botão finalizar edição')
            }

            if (exec) {
                this.loading = true;
                axios.post('/student/essays/' + this.essay.id + '/resend', this.form)
                    .then((result) => {
                        // Reload
                        window.location.reload();

                        // Clear Errors
                        this.errors = {}
                    })
                    .catch((errors) => {
                        // Check Errors
                        this.errors = this.setErrors(errors)
                    })
                    .finally(() => this.loading = false)
            }
        },

        loadImage() {
            if (this.$refs.file.files[0]) {
                this.optimizeImage(this.$refs.file.files[0])
            }
        },

        optimizeImage(inputImage) {

            this.loadingOptimize = true;

            let formData = new FormData();

            formData.append('image', inputImage)

            axios.post('/student/essays/optimize-image', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((result) => {

                    this.preview = result.data.data.urlImage

                })
                .finally(() => this.loadingOptimize = false)
        },

        cropImage() {
            const { canvas } = this.$refs.cropper.getResult();
            this.form.content_img_path = canvas.toDataURL();
        },

        changeImage() {
            this.preview = null;
            this.form.content_img_path = null
        },

        rotate(angle) {
            this.$refs.cropper.rotate(angle);
        },

        handleImageSuccess(data) {
            if (data.pathConverted) {

                if (this.imageConvertInterval) {
                    clearInterval(this.imageConvertInterval)
                }

                this.imageConvertPath = data.pathConverted;

                this.imageConvertInterval = setInterval(() => {
                    axios.post('/check-if-path-exists', {
                        path: this.imageConvertPath
                    })
                        .then((result) => {
                            let response = result.data;

                            if (response.exist) {
                                this.preview = response.url;
                                this.form.content_img_path = this.imageConvertPath;

                                this.imageConvertPath = null;
                                clearInterval(this.imageConvertInterval)
                            }
                        })
                }, this.imageConvertIntervalTime)

            } else {

                if (this.imageConvertInterval) {
                    clearInterval(this.imageConvertInterval)
                }

                this.imageConvertPath = null;
                this.preview = data.url;
                this.form.content_img_path = data.path;
            }
        },

        clearImage() {
            this.preview = null;
            this.form.content_img_path = null;
        },
    }
}
</script>

<style scoped>

</style>
